export const WAG_NO_QUOTES_CTA =
  "We can manually pull quotes for you — just let us know what you're looking for and we'll get it added to your profile.";

export const NON_WAG_NO_QUOTES_CTA =
  'Your advisor or agent can help you find quotes outside of Waterlily and upload them using the policy upload feature so you can still model them in your plan.';
